import { takeEvery } from "redux-saga/effects";
import {
  fetchContents,
  fetchContentsStart,
  fetchContentsSuccess,
  fetchContentsFailure,
} from "@/store/slices/contents";
import { fetcherForSagas } from "@/store/fetcherForSagas";
import { requestContentsShow } from "@/features/contents/api/requests";

function* contents() {
  yield takeEvery(
    fetchContents,
    fetcherForSagas({
      start: fetchContentsStart,
      success: fetchContentsSuccess,
      failure: fetchContentsFailure,
      request: ({ payload }: any) =>
        requestContentsShow({
          machine_name: payload.machine_name,
          published: 1,
        }),
    })
  );
}

export default contents;
